import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18d84242"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { PropType, computed, StyleValue } from 'vue'
import { PPTTextElement } from '@/types/slides'
import ElementOutline from '@/views/components/element/ElementOutline.vue'

import useElementShadow from '@/views/components/element/hooks/useElementShadow'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTextElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTTextElement>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const shadow = computed(() => props.elementInfo.shadow)
const { shadowStyle } = useElementShadow(shadow)

const cssVar = computed(() => ({
  '--textIndent': `${props.elementInfo.textIndent || 0}px`,
  '--paragraphSpace': `${props.elementInfo.paragraphSpace === undefined ? 5 : props.elementInfo.paragraphSpace}px`,
} as StyleValue))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-text",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", {
        class: "element-content",
        style: _normalizeStyle({
          width: __props.elementInfo.vertical ? 'auto' : __props.elementInfo.width + 'px',
          height: __props.elementInfo.vertical ? __props.elementInfo.height + 'px' : 'auto',
          backgroundColor: __props.elementInfo.fill,
          opacity: __props.elementInfo.opacity,
          textShadow: _unref(shadowStyle),
          lineHeight: __props.elementInfo.lineHeight,
          letterSpacing: (__props.elementInfo.wordSpace || 0) + 'px',
          color: __props.elementInfo.defaultColor,
          fontFamily: __props.elementInfo.defaultFontName,
          writingMode: __props.elementInfo.vertical ? 'vertical-rl' : 'horizontal-tb',
        })
      }, [
        _createVNode(ElementOutline, {
          width: __props.elementInfo.width,
          height: __props.elementInfo.height,
          outline: __props.elementInfo.outline
        }, null, 8, ["width", "height", "outline"]),
        _createElementVNode("div", {
          class: "text ProseMirror-static",
          style: _normalizeStyle(_unref(cssVar)),
          innerHTML: __props.elementInfo.content
        }, null, 12, _hoisted_1)
      ], 4)
    ], 4)
  ], 4))
}
}

})